import React, { useState, ReactElement } from 'react'

import './TipsRotator.scss'

type TipsType = string | string[] | ReactElement<any>

export interface IProps {
  tips: TipsType
  label?: string
  tipClass?: string
}

const BASE_CLASS = 'tips-rotator'

const TipsRotator = ({ tips, label, tipClass }: IProps) => {
  const [tipIndex, setTipIndex] = useState(0)
  const [containerClass, setContainerClass] = useState(BASE_CLASS)

  const isArrayExtended = (value: TipsType) => Array.isArray(value) && value.length > 1

  const visibleTip = Array.isArray(tips) && isArrayExtended(tips) ? tips[tipIndex] : tips
  const finalLabel = label || 'TIP:'

  const switchTip = (index: number) => {
    setContainerClass(BASE_CLASS + ' fade-out')
    setTimeout(() => {
      setTipIndex(index)
      setContainerClass(BASE_CLASS + ' fade-in')
    }, 500)
  }

  const showNext = () => {
    if (!Array.isArray(tips) || !isArrayExtended(tips)) {
      return
    }
    let newIndex = tipIndex + 1
    if (newIndex > tips.length - 1) {
      newIndex = 0
    }
    switchTip(newIndex)
  }
  const showPrev = () => {
    if (!Array.isArray(tips) || !isArrayExtended(tips)) {
      return
    }
    let newIndex = tipIndex - 1
    if (newIndex < 0) {
      newIndex = tips.length - 1
    }
    switchTip(newIndex)
  }

  return (
    <span className={containerClass} data-testid='tips-rotator'>
      {isArrayExtended(tips) && (
        <div className='icon-area' onClick={showPrev} data-testid='tips-rotator-prev'>
          <div className='icon-caret icon-caret-left'></div>
        </div>
      )}
      <div className={tipClass ? tipClass : 'csas-tip'} data-testid='tips-rotator-tip'>
        <strong>{finalLabel}</strong>
        <span> {visibleTip}</span>
      </div>
      {isArrayExtended(tips) && (
        <div className='icon-area' onClick={showNext} data-testid='tips-rotator-next'>
          <div className='icon-caret icon-caret-right'></div>
        </div>
      )}
    </span>
  )
}

export default TipsRotator
